import CardDesign from "../components/cardDesign";
import useAllFreeDeliveryProducts from "hook/useAllFreeDeliveryProducts";
import { FaTag, FaTruck } from "react-icons/fa";
import { useSettings } from "context/SettingsContext";
import { t } from "context/translations";
import ScrollToTopButton from "components/ScrollToTopButton";
import TrendingProducts from "components/dashboardComponents/trendingProducts";
import freeDeliveryBanner from "../images/freeDeliveryBanner.webp";

const FreeDeliveryFullPage = () => {
  const { allFreeDeliveryProducts, loading1, error } = useAllFreeDeliveryProducts();
  const {  language } = useSettings();
  return (
    <div className=" flex flex-col min-h-[100dvh]">
      {/* <Navbar /> */}
      <div className="relative rounded-md mb-5 md:max-w-7xl mx-auto">
        {/* ✅ Data */}
        {!loading1 && !error && allFreeDeliveryProducts.length > 0 && (
          <div className="mb-3">
            <section className="overflow-hidden sm:mb-8 mb-5 bg-slate-900 text-white shadow-lg">
              <div className="relative">
                <div className="absolute inset-0">
                  <img
                    src={freeDeliveryBanner}
                    alt="Free delivery banner"
                    className="h-full w-full object-cover opacity-25"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-emerald-950/95 via-slate-900/85 to-cyan-900/70" />
                </div>
                <div className="relative p-5 sm:px-10">
                  <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
                    <div>
                      <p className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-emerald-100">
                        <FaTruck />
                        {t("zeroShipping", language)}
                      </p>
                      <h1 className="mt-2 text-2xl font-extrabold sm:text-3xl">
                        {t("freeDeliveryProduct", language)}
                      </h1>
                      <p className="mt-2 max-w-xl text-sm text-slate-200 sm:text-base">
                        {t("freeShippingTitle", language)}
                      </p>
                    </div>
                    <div className=" flex flex-wrap items-center gap-2 text-xs font-semibold text-slate-200">
                      <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-3 py-2">
                        <FaTruck />
                        {t("alwaysFreeDelivery", language)}
                      </span>
                      <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-3 py-2">
                        <FaTag />
                        {t("discountIncluded", language)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <CardDesign likeData={allFreeDeliveryProducts} />
          </div>
        )}
      </div>
      <TrendingProducts />
      <ScrollToTopButton />
    </div>
  );
};

export default FreeDeliveryFullPage;
